import React from "react";
import { HelpPanel } from "@amzn/awsui-components-console";
import { ExternalLinkGroup } from "../../commons";
import { learnMoreLinks } from "src/pages/commons/learn-more-links";

export function ToolsContent() {
  return (
    <HelpPanel
      header={<h2>Redrive Workflow Resource</h2>}
      footer={<ExternalLinkGroup items={learnMoreLinks} />}
    >
      <p>Redrive the workflow with external id.</p>
      <ul>
        <li>Please input the external id and workflow type.</li>
        <li>
          Event version override is an optional field for FUSEN workflows.
        </li>
        <li>
          Create new workflow is an optional field for FUSEN workflows. This
          flag will create a new FUSEN workflow by default and will not resort
          to finding a previous work item (example usage: redriving workflows
          that only existing on ORCA DUB prior to ZAZ migration), we can use
          FBTSV2 using external id to open Fusen workflow. Note that if this is
          enabled, event version override does not work as expected to check the
          previous override value.
        </li>
        <li>Environment is required if create fusen workflow field is true.</li>
        <li>
          Redrive latest work item is an optional field for all workflows.
        </li>
      </ul>
    </HelpPanel>
  );
}
